import AudiologyIcon from "./department_icon/Audiology.png";
import AyurvedicMedicineandSurgeryIcon from "./department_icon/Ayurvedic Medicine and Surgery.png";
import AllergyandImmunologyIcon from "./department_icon/Allergy and Immunology.png";
import AnesthesiologyIcon from "./department_icon/Anesthesiology.png";
import BiotechnologyIcon from "./department_icon/Biotechnology.png";
import CardiologyIcon from "./department_icon/Cardiology.png";
import ClinicalResearchIcon from "./department_icon/Clinical Research.png";
import ColonAndRectalSurgeryIcon from "./department_icon/Colon and Rectal Surgery.png";
import DentalMedicineIcon from "./department_icon/Dental Medicine.png";
import DermatologyIcon from "./department_icon/Dermatology.png";
import DiagnosticRadiologyIcon from "./department_icon/Diagnostic radiology.png";
import EmbalmingAndMortuaryScienceIcon from "./department_icon/Embalming and Mortuary Science.png";
import EmergencyMedicineIcon from "./department_icon/Emergency Medicine.png";
import ENTIcon from "./department_icon/ent otorhinolaryngology.png";
import EpidemiologyIcon from "./department_icon/Epidemiology.png";
import FamilyMedicineIcon from "./department_icon/Family Medicine.png";
import ForensicPathologyIcon from "./department_icon/Forensic Pathology.png";
import GastroenterologyIcon from "./department_icon/Gastroenterology.png";
import GeneralMedicineIcon from "./department_icon/General Medicine.png";
import GeneralSurgeryIcon from "./department_icon/General Surgery.png";
import GeneticsAndGenomicsIcon from "./department_icon/Genetics and Genomics.png";
import GeneticsIcon from "./department_icon/Genetics.png";
import HomoeopathyIcon from "./department_icon/Homoeopathy.png";
import HospitalMedicineIcon from "./department_icon/Hospital Medicine.png";
import ImmunologyIcon from "./department_icon/Immunology.png";
import InternalMedicineIcon from "./department_icon/Internal Medicine.png";
import MedicalElectronicsEngineeringIcon from "./department_icon/Medical Electronics Engineering.png";
import MicrobiologyIcon from "./department_icon/Microbiology.png";
import NephrologyIcon from "./department_icon/Nephrology.png";
import NeuroSurgeryIcon from "./department_icon/Neuro Surgery.png";
import NeurologyIcon from "./department_icon/Neurology.png";
import NeuroscienceIcon from "./department_icon/Neuroscience.png";
import NuclearMedicineIcon from "./department_icon/Nuclear Medicine.png";
import NursingIcon from "./department_icon/Nursing.png";
import NutritionAndDieteticsIcon from "./department_icon/Nutrition and Dietetics.png";
import ObstetricsAndGynecologyIcon from "./department_icon/Obstetrics and Gynecology.png";
import OccupationalTherapyIcon from "./department_icon/Occupational Therapy.png";
import OperationTheatreTechnologyIcon from "./department_icon/Operation Theatre Technology.png";
import OphthalmicSurgeryIcon from "./department_icon/Ophthalmic Surgery.png";
import PathologyIcon from "./department_icon/Pathology.png";
import PediatricsIcon from "./department_icon/Pediatrics.png";
import PharmacyIcon from "./department_icon/Pharmacy.png";
import PhysicalMedicineAndRehabilitationIcon from "./department_icon/Physical Medicine and Rehabilitation.png";
import PlasticSurgeryIcon from "./department_icon/Plastic Surgery.png";
import PreventiveMedicineIcon from "./department_icon/Preventive Medicine.png";
import PsychiatryIcon from "./department_icon/Psychiatry.png";
import PulmonologyIcon from "./department_icon/Pulmonology.png";
import RadiationOncologyIcon from "./department_icon/Radiation oncology.png";
import RadiologyIcon from "./department_icon/Radiology.png";
import RespiratoryTherapyIcon from "./department_icon/Respiratory Therapy.png";
import RheumatologyIcon from "./department_icon/Rheumatology.png";
import SleepMedicineIcon from "./department_icon/Sleep Medicine.png";
import ThoracicSurgeryIcon from "./department_icon/Thoracic Surgery.png";
import UnaniIcon from "./department_icon/Unani.png";
import UrologyIcon from "./department_icon/Urology.png";
import VeterinaryMedicineIcon from "./department_icon/Veterinary Medicine.png";
import SurgeryIcon from './department_icon/Surgery_icon.svg'
const dummyData = {
  medicines: [
    { mid: 1, name: "*&*Paracetamol", seller: "ABC Pharmacy", type: "vendor" },
    { mid: 2, name: "Ibuprofen", seller: "XYZ Drugstore", type: "vendor" },
    { mid: 3, name: "Amoxicillin", seller: "PharmaMart", type: "vendor" },
    { mid: 4, name: "Loratadine", seller: "MediHealth", type: "vendor" },
    { mid: 5, name: "Omeprazole", seller: "Sunrise Pharmacy", type: "vendor" },
  ],
};

export const departmentData = [
  {
    id: 1,
    departmentName: "Audiology",
    icon: AudiologyIcon,
    subDepartments: [],
  },
  {
    id: 2,
    departmentName: "Ayurvedic Medicine and Surgery",
    icon: AyurvedicMedicineandSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 3,
    departmentName: "Allergy and Immunology",
    icon: AllergyandImmunologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Critical Care Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Hospice and Palliative Care",
      },
      {
        id: 3,
        subDepartmentName: "Pain Medicine",
      },
      {
        id: 4,
        subDepartmentName: "Pediatric Anesthesiology",
      },
      {
        id: 5,
        subDepartmentName: "Sleep Medicine",
      },
    ],
  },
  {
    id: 4,
    departmentName: "Anesthesiology",
    icon: AnesthesiologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Anaesthesia",
      },

      {
        id: 2,
        subDepartmentName: "Critical Emergency Medicine",
      },
      {
        id: 3,
        subDepartmentName: "Intensive Care Medicine",
      },
    ],
  },
  {
    id: 5,
    departmentName: "Biotechnology",
    icon: BiotechnologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Medical Biotechnology",
      },
    ],
  },
  {
    id: 6,
    departmentName: "Cardiology",
    icon: CardiologyIcon,
    subDepartments: [],
  },
  {
    id: 7,
    departmentName: "Clinical Research",
    icon: ClinicalResearchIcon,
    subDepartments: [],
  },
  {
    id: 8,
    departmentName: "Colon and Rectal Surgery",
    icon: ColonAndRectalSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 9,
    departmentName: "Dental Medicine",
    icon: DentalMedicineIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Conservative Dentistry & Endodontics",
      },
      {
        id: 2,
        subDepartmentName: "Dental Education",
      },
      {
        id: 3,
        subDepartmentName: "Dental Surgery",
      },
      {
        id: 4,
        subDepartmentName: "Diploma Dent. Tech.",
      },
      {
        id: 5,
        subDepartmentName: "Oral and Maxillofacial Surgery",
      },
      {
        id: 6,
        subDepartmentName: "Oral Medicine and Radiology",
      },
      {
        id: 7,
        subDepartmentName: "Oral Pathology and Microbiology",
      },
      {
        id: 8,
        subDepartmentName: "Orthodontics and Dentofacial Orthopaedics",
      },
      {
        id: 9,
        subDepartmentName: "Paediatic and Preventive Dentistry",
      },
      {
        id: 10,
        subDepartmentName: "Periodontology",
      },
      {
        id: 11,
        subDepartmentName: "Prosthodontics, Crown and Bridge",
      },
      {
        id: 12,
        subDepartmentName: "Public Health Dentistry",
      },
    ],
  },
  {
    id: 10,
    departmentName: "Dermatology",
    icon: DermatologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Dermatopathlogy",
      },
      {
        id: 2,
        subDepartmentName: "Pediatric Dermatology",
      },
      {
        id: 3,
        subDepartmentName: "Procedural Dermatology",
      },
    ],
  },
  {
    id: 11,
    departmentName: "Diagnostic Radiology",
    icon: DiagnosticRadiologyIcon,
    subDepartments: [],
  },
  {
    id: 12,
    departmentName: "Embalming and Mortuary Science",
    icon: EmbalmingAndMortuaryScienceIcon,
    subDepartments: [],
  },
  {
    id: 13,
    departmentName: "Emergency Medicine",
    icon: EmergencyMedicineIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Anesthesiology Critical Care Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Emergency Medical Services",
      },
      {
        id: 3,
        subDepartmentName: "Hospice and Palliative Medicine",
      },
      {
        id: 4,
        subDepartmentName: "Internal Medicine / Critical Care Medicine",
      },
      {
        id: 5,
        subDepartmentName: "Medical Toxicology",
      },
      {
        id: 6,
        subDepartmentName: "Pain Medicine",
      },
    ],
  },
  { id: 14, departmentName: "ENT", icon: ENTIcon, subDepartments: [] },
  {
    id: 15,
    departmentName: "Epidemiology",
    icon: EpidemiologyIcon,
    subDepartments: [],
  },
  { id: 16, departmentName: "Family Medicine", icon: FamilyMedicineIcon, subDepartments: [] },
  {
    id: 17,
    departmentName: "Forensic Pathology",
    icon: ForensicPathologyIcon,
    subDepartments: [],
  },
  {
    id: 18,
    departmentName: "Gastroenterology",
    icon: GastroenterologyIcon,
    subDepartments: [],
  },
  {
    id: 19,
    departmentName: "General Medicine",
    icon: GeneralMedicineIcon,
    subDepartments: [],
  },
  {
    id: 20,
    departmentName: "General Surgery",
    icon: GeneralSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 21,
    departmentName: "Genetics and Genomics",
    icon: GeneticsAndGenomicsIcon,
    subDepartments: [],
  },
  {
    id: 22,
    departmentName: "Genetics",
    icon: GeneticsIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Genetics and Microbiology",
      },
      {
        id: 2,

        subDepartmentName: "Genetics, Microbiology, Chemistry",
      },
    ],
  },
  {
    id: 23,
    departmentName: "Homoeopathy",
    icon: HomoeopathyIcon,
    subDepartments: [],
  },
  {
    id: 24,
    departmentName: "Hospital Medicine",
    icon: HospitalMedicineIcon,
    subDepartments: [],
  },
  {
    id: 25,
    departmentName: "Immunology",
    icon: ImmunologyIcon,
    subDepartments: [],
  },
  {
    id: 26,
    departmentName: "Internal Medicine",
    icon: InternalMedicineIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Advanced Heart Failure and Transplant Cardiology",
      },
      {
        id: 2,
        subDepartmentName: "Cardiovascular Disease",
      },
      {
        id: 3,
        subDepartmentName: "Clinical Cardiac Eletrophysiology",
      },
      {
        id: 4,
        subDepartmentName: "Critical Care Medicine",
      },
      {
        id: 5,
        subDepartmentName: "Endocrinology, Diabetes, and Metabolism",
      },

      {
        id: 6,
        subDepartmentName: "Gastroenterology",
      },
      {
        id: 7,
        subDepartmentName: "Geriatric Medicine",
      },
      {
        id: 8,
        subDepartmentName: "Hematology",
      },
      {
        id: 9,
        subDepartmentName: "Hematology and Oncology",
      },
      {
        id: 10,
        subDepartmentName: "Intectious disease",
      },
      {
        id: 11,
        subDepartmentName: "Internal Medicine",
      },
      {
        id: 12,
        subDepartmentName: "Interventional Cardiology",
      },
      {
        id: 12,
        subDepartmentName: "Nephrology",
      },
      {
        id: 13,
        subDepartmentName: "Oncology",
      },
      {
        id: 14,
        subDepartmentName: "Pediatric Internal Medicine",
      },
      {
        id: 15,
        subDepartmentName: "Pulmonary Disease",
      },
      {
        id: 16,
        subDepartmentName: "Pulmonary Disease and Critical Care Medicine",
      },
      {
        id: 17,
        subDepartmentName: "Rheumatology",
      },
      {
        id: 18,
        subDepartmentName: "Sleep Medicine",
      },
      {
        id: 19,
        subDepartmentName: "Sports Medicine",
      },
      {
        id: 20,
        subDepartmentName: "Transplant Hepatology",
      },
    ],
  },
  {
    id: 27,
    departmentName: "Medical Electronics Engineering",
    icon: MedicalElectronicsEngineeringIcon,
    subDepartments: [],
  },
  {
    id: 28,
    departmentName: "Microbiology",
    icon: MicrobiologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Microbiology, Chemistry, Genetice",
      },
      {
        id: 2,
        subDepartmentName: "Microbiology,Genetics, and Biochemistry",
      },
      {
        id: 3,
        subDepartmentName: "Pharmaceuticavl Microbiology",
      },
      {
        id: 4,
        subDepartmentName: "Microbiology, Chemistry",
      },
      {
        id: 5,
        subDepartmentName:
          "Medical Microbiology and Applied Molecular Biology Hons",
      },
    ],
  },
  {
    id: 29,
    departmentName: "Nephrology",
    icon: NephrologyIcon,
    subDepartments: [],
  },
  {
    id: 30,
    departmentName: "Neuro Surgery",
    icon: NeuroSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 31,
    departmentName: "Neurology",
    icon: NeurologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Brain Injury Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Child Neurology",
      },
      {
        id: 3,
        subDepartmentName: "Clinical Neurophysiology",
      },
      {
        id: 4,
        subDepartmentName: "Endovascular Surgical Neuroradiology",
      },
      {
        id: 5,
        subDepartmentName: "Hospice and Palliative Medicine",
      },
      {
        id: 6,
        subDepartmentName: "Neurodevelopmental Disablities",
      },
      {
        id: 7,
        subDepartmentName: "Neurodevelopmental Medicine",
      },
      {
        id: 8,
        subDepartmentName: "Pain Medicine",
      },
      {
        id: 9,
        subDepartmentName: "Sleep Medicine",
      },
      {
        id: 10,
        subDepartmentName: "Vascular Neurology",
      },
    ],
  },
  {
    id: 32,
    departmentName: "Neuroscience",
    icon: NeuroscienceIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Neurosciences Hons Non-Medical",
      },
      {
        id: 2,
        subDepartmentName: "Neuro Technology",
      },
      {
        id: 3,
        subDepartmentName: "Neurochemistry",
      },
      {
        id: 4,
        subDepartmentName: "Neurophysiology",
      },
    ],
  },
  {
    id: 33,
    departmentName: "Nuclear Medicine",
    icon: NuclearMedicineIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Nuclear Medicine Technology",
      },
    ],
  },
  {
    id: 34,
    departmentName: "Nursing",
    icon: NursingIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "General Nursing and Midwifery",
      },
    ],
  },
  {
    id: 35,
    departmentName: "Nutrition and Dietetics",
    icon: NutritionAndDieteticsIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Clinical Dietetics",
      },
      {
        id: 2,
        subDepartmentName: "Clinical Nutrition and Dietetices",
      },
      {
        id: 3,
        subDepartmentName: "Clinical Nutrition",
      },
      {
        id: 4,
        subDepartmentName: "Nutrition and Dietetics",
      },
      {
        id: 5,
        subDepartmentName: "Nutrition and Dietetics, Chemistry and Zoology",
      },
    ],
  },
  {
    id: 36,
    departmentName: "Obstetrics and Gynecology",
    icon: ObstetricsAndGynecologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Female Pelvic Medicine and Reconstructive Surgery",
      },
      {
        id: 2,
        subDepartmentName: "Gynecologic Oncology",
      },
      {
        id: 3,
        subDepartmentName: "Maternal-Fetal Medicine",
      },
      {
        id: 4,
        subDepartmentName: "Reproductive endocrinologists and Intertility",
      },
    ],
  },
  {
    id: 37,
    departmentName: "Occupational Therapy",
    icon: OccupationalTherapyIcon,
    subDepartments: [],
  },
  {
    id: 38,
    departmentName: "Operation Theatre Technology",
    icon: OperationTheatreTechnologyIcon,
    subDepartments: [],
  },
  {
    id: 39,
    departmentName: "Ophthalmic Surgery",
    icon: OphthalmicSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 40,
    departmentName: "Pathology",
    icon: PathologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Anatomical Pathology",
      },
      {
        id: 2,
        subDepartmentName: "Blood Banking and Transfusion Medicine",
      },
      {
        id: 3,
        subDepartmentName: "Chemical Pathology",
      },
      {
        id: 4,
        subDepartmentName: "Clinical Pathology",
      },
      {
        id: 5,
        subDepartmentName: "Cytopathology",
      },
      {
        id: 6,
        subDepartmentName: "Forensic Pathology",
      },
      {
        id: 7,
        subDepartmentName: "Genetic Pathology",
      },
      {
        id: 8,
        subDepartmentName: "Hematology",
      },
      {
        id: 9,
        subDepartmentName: "Immunopathology",
      },
      {
        id: 10,
        subDepartmentName: "Medical Microbiology",
      },
      {
        id: 11,
        subDepartmentName: "Molecular Pathology",
      },
      {
        id: 12,
        subDepartmentName: "Neuropathology",
      },
      {
        id: 13,
        subDepartmentName: "Pediatric Pathology",
      },
    ],
  },
  {
    id: 41,
    departmentName: "Pediatrics",
    icon: PediatricsIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Adolescent Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Child Abuse Pediatrics",
      },
      {
        id: 3,
        subDepartmentName: "Developmental-Behavioral Pediatrics",
      },
      {
        id: 4,
        subDepartmentName: "Neonatal-Perinatal Medicine",
      },
      {
        id: 5,
        subDepartmentName: "Pediatric Cardiology",
      },
      {
        id: 6,
        subDepartmentName: "Pediatric Critical Care Medicine",
      },
      {
        id: 7,
        subDepartmentName: "Pediatric Endocrinology",
      },
      {
        id: 8,
        subDepartmentName: "Pediatric Gastroenterology",
      },
      {
        id: 8,
        subDepartmentName: "Pediatric Hematology-oncology",
      },
      {
        id: 9,
        subDepartmentName: "Pediatric Infectious Diseases",
      },
      {
        id: 10,
        subDepartmentName: "Pediatric Nephrology",
      },
      {
        id: 11,
        subDepartmentName: "Pediatric Pulmonology",
      },
      {
        id: 12,
        subDepartmentName: "Pediatric Rheumatology",
      },
      {
        id: 13,
        subDepartmentName: "Pediatric Sports Medicine",
      },
      {
        id: 14,
        subDepartmentName: "Pediatric Transplant Hepatology",
      },
    ],
  },
  {
    id: 42,
    departmentName: "Pharmacy",
    icon: PharmacyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Pharmaceutical Chemistry and Technology",
      },
      {
        id: 2,
        subDepartmentName: "Pharmaceutical Science",
      },

      {
        id: 3,
        subDepartmentName: "Pharma Business Management",
      },
      {
        id: 4,
        subDepartmentName: "Unani Pharmacy",
      },
    ],
  },
  {
    id: 43,
    departmentName: "Physical Medicine and Rehabilitation",
    icon: PhysicalMedicineAndRehabilitationIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Brain Injury Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Hospice and Palliative Medicine",
      },
      {
        id: 3,
        subDepartmentName: "Neuromuscular Medicine",
      },
      {
        id: 4,
        subDepartmentName: "Pain Medicine",
      },
      {
        id: 5,
        subDepartmentName: "Pediatric Rehabilitation Medicine",
      },
      {
        id: 6,
        subDepartmentName: "Spinal Cord Injury Medicine",
      },
      {
        id: 7,
        subDepartmentName: "Sports Medicine",
      },
    ],
  },
  {
    id: 44,
    departmentName: "Plastic Surgery",
    icon: PlasticSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 45,
    departmentName: "Preventive Medicine",
    icon: PreventiveMedicineIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Aerospace Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Medical Toxicology",
      },
      {
        id: 3,
        subDepartmentName: "Occupational Medicine",
      },
      {
        id: 4,
        subDepartmentName: "Public Health Medicine",
      },
    ],
  },
  {
    id: 46,
    departmentName: "Psychiatry",
    icon: PsychiatryIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Addiction Psychiatry",
      },
      {
        id: 2,
        subDepartmentName: "Administrative Psychiatry",
      },
      {
        id: 3,
        subDepartmentName: "Child and Adolescent Psychiatry",
      },
      {
        id: 4,
        subDepartmentName: "Community Psychiatry",
      },
      {
        id: 5,
        subDepartmentName: "Consultation/liaison Psychiatry",
      },
      {
        id: 6,
        subDepartmentName: "Emergency Psychiatry",
      },
      {
        id: 7,
        subDepartmentName: "Forensic Psychiatry",
      },
      {
        id: 8,
        subDepartmentName: "Geriatric Psychiatry",
      },
      {
        id: 9,
        subDepartmentName: "Mental Retardation Psychiatry",
      },
      {
        id: 10,
        subDepartmentName: "Military Psychiatry",
      },
      {
        id: 11,
        subDepartmentName: "Pain Medicine",
      },
      {
        id: 12,
        subDepartmentName: "Psychiatric research",
      },
      {
        id: 13,
        subDepartmentName: "Psychosomatic Medicine",
      },
    ],
  },
  {
    id: 47,
    departmentName: "Pulmonology",
    icon: PulmonologyIcon,
    subDepartments: [],
  },
  {
    id: 48,
    departmentName: "Radiation Oncology",
    icon: RadiationOncologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Hospice and Palliative Medicine",
      },
      {
        id: 2,
        subDepartmentName: "Pain Medicine",
      },
    ],
  },
  {
    id: 49,
    departmentName: "Radiology",
    icon: RadiologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Abdominal Radiology",
      },
      {
        id: 2,
        subDepartmentName: "Breast Imaging",
      },
      {
        id: 3,
        subDepartmentName: "Cardiothoracic Radiology",
      },
      {
        id: 4,
        subDepartmentName: "Cardiovascular Radiology",
      },
      {
        id: 5,
        subDepartmentName: "Chest Radiology",
      },
      {
        id: 6,
        subDepartmentName: "Emergency Radiology",
      },
      {
        id: 7,
        subDepartmentName: "Endovascular Surgical Neuroradiology",
      },
      {
        id: 8,
        subDepartmentName: "Gastrointestinal Radiology",
      },
      {
        id: 9,
        subDepartmentName: "Genitourinary Radiology",
      },
      {
        id: 10,
        subDepartmentName: "Head and Neck Radiology",
      },
      {
        id: 11,
        subDepartmentName: "Interventional Radiology",
      },
      {
        id: 12,
        subDepartmentName: "Musculoskeletal Radiology",
      },
      {
        id: 13,
        subDepartmentName: "Neuroradiology",
      },
      {
        id: 14,
        subDepartmentName: "Nuclear Radiology",
      },
      {
        id: 15,
        subDepartmentName: "Pediatric Radiology",
      },
      {
        id: 16,
        subDepartmentName: "Radiation oncology",
      },
      {
        id: 17,
        subDepartmentName: "Vascular and Interventional Radiology",
      },
    ],
  },
  {
    id: 50,
    departmentName: "Respiratory Therapy",
    icon: RespiratoryTherapyIcon,
    subDepartments: [],
  },
  {
    id: 51,
    departmentName: "Rheumatology",
    icon: RheumatologyIcon,
    subDepartments: [],
  },
  {
    id: 52,
    departmentName: "Sleep Medicine",
    icon: SleepMedicineIcon,
    subDepartments: [],
  },
  {
    id: 53,
    departmentName: "Thoracic Surgery",
    icon: ThoracicSurgeryIcon,
    subDepartments: [],
  },
  {
    id: 54,
    departmentName: "Unani",
    icon: UnaniIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Unani Medicine and Surgery",
      },
      {
        id: 2,
        subDepartmentName: "Unani Pharmacy",
      },
    ],
  },
  {
    id: 55,
    departmentName: "Urology",
    icon: UrologyIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Pediatric Urology",
      },
      {
        id: 2,
        subDepartmentName: "Urologic Oncology",
      },
      {
        id: 3,
        subDepartmentName: "Renal Transplant",
      },
      {
        id: 4,
        subDepartmentName: "Male Infertility",
      },
      {
        id: 5,
        subDepartmentName: "Calculi",
      },
      {
        id: 6,
        subDepartmentName: "Female Urology",
      },
      {
        id: 7,
        subDepartmentName: "Neurourology",
      },
    ],
  },
  {
    id: 56,
    departmentName: "Veterinary Medicine",
    icon: VeterinaryMedicineIcon,
    subDepartments: [],
  },
  {
    id: 57,
    departmentName: "Diagnostic Radiology",
    icon: DiagnosticRadiologyIcon,
    subDepartments: [],
  },
  {
    id: 58,
    departmentName: "Surgery",
    icon: SurgeryIcon,
    subDepartments: [
      {
        id: 1,
        subDepartmentName: "Colon and Rectal Surgery",
      },
      {
        id: 2,
        subDepartmentName: "General Surgery",
      },
      {
        id: 3,
        subDepartmentName: "Surgical Critical Care",
      },
      {
        id: 4,
        subDepartmentName: "Gynecologic Oncology",
      },
      {
        id: 5,
        subDepartmentName: "Plastic Surgery",
      },
      {
        id: 6,
        subDepartmentName: "Craniofacial Surgery",
      },
      {
        id: 7,
        subDepartmentName: "Hand Surgery",
      },
      {
        id: 8,
        subDepartmentName: "Neurological Surgery",
      },
      {
        id: 9,
        subDepartmentName: "Endovascular Surgical Neuroradiology",
      },
      {
        id: 10,
        subDepartmentName: "Ophthalmic Surgery",
      },
      {
        id: 11,
        subDepartmentName: "Oral and Maxillofacial Surgary",
      },
      {
        id: 12,
        subDepartmentName: "Orthopaedic Surgery",
      },
      {
        id: 13,
        subDepartmentName: "Adult Reconstructive Orthopaedics",
      },
      {
        id: 14,
        subDepartmentName: "Foot and ankle Orthopaedics",
      },
      {
        id: 15,
        subDepartmentName: "Musculoskeletal Oncology",
      },
      {
        id: 16,
        subDepartmentName: "Orthopaedic Surgery of the Spine",
      },
      {
        id: 17,
        subDepartmentName: "Orthopaedic Trauma",
      },
      {
        id: 18,
        subDepartmentName: "Pediatric Orthopaedics",
      },
      {
        id: 19,
        subDepartmentName: "Otolaryngology",
      },
      {
        id: 20,
        subDepartmentName: "Pediatic Otolaryngology",
      },
      {
        id: 21,
        subDepartmentName: "Otology Neurotology",
      },
      {
        id: 22,
        subDepartmentName: "Pediatric Surgery",
      },
      {
        id: 23,
        subDepartmentName: "Neonatal",
      },
      {
        id: 24,
        subDepartmentName: "Prenatal",
      },
      {
        id: 25,
        subDepartmentName: "Trauma",
      },
      {
        id: 26,
        subDepartmentName: "Pediatric Oncology",
      },
      {
        id: 27,
        subDepartmentName:
          "Surgical Intensivists, specializing in critical care Patients",
      },
      {
        id: 28,
        subDepartmentName: "Thoracic Surgery",
      },
      {
        id: 29,
        subDepartmentName: "Congential Cardiac Surgery",
      },
      {
        id: 30,
        subDepartmentName: "Thoracic Surgery-Integrated",
      },
      {
        id: 31,
        subDepartmentName: "Vascular Surgery",
      },
    ],
  },
];

export default dummyData;
